export default {
  setFilterData: (state, data) => {
    state.filterData = data;
  },
};
